// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"c8f84796","801":"ae4d8652","894":"1920a642","895":"dc1688c8"}[chunkId] + ".css";
};